import ActivityModule from "@/views/activityMeet/index.vue";

export const activityRoutes = [
  // 活动会议
  {
    path: "/activity",
    component: ActivityModule,
    redirect: "/activity",
    meta: {
      title: "activity",
    },
    children: [
      {
        path: "/activity",
        name: "activity",
        meta: {
          title: "天晟-活动",
        },
        components: {
          default: () => import("@/views/activityMeet/activity-list/index.vue"),
        },
      },
      {
        path: "/activity-detail/:id",
        name: "activity-detail",
        meta: {
          title: "天晟-活动详情",
        },
        components: {
          default: () =>
            import("@/views/activityMeet/activity-detail/activity-detail.vue"),
        },
      },
    ],
  },
];
